export enum PathParamKeys {
  statementId = 'statementId',
  spouseId = 'spouseId',
  childId = 'childId',
  stepNo = 'step',
  activationKey = 'activationKey',
}
